import { render, staticRenderFns } from "./WarehouseSubstandardReport.vue?vue&type=template&id=638a1e01&"
import script from "./WarehouseSubstandardReport.vue?vue&type=script&lang=ts&"
export * from "./WarehouseSubstandardReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports